import React from 'react';
import { MessageSquareText } from 'lucide-react';
import BrowserFrame from './BrowserFrame';
import chatDashboardImage from '../../assets/erica/chat-dashboard.png';
import { COPY } from '../../i18n/copy';
import { useI18n } from '../../i18n/useI18n';

const EricaDemoStory: React.FC = () => {
  const { lang } = useI18n();
  const c = COPY[lang];

  return (
    <section id="demo-story" className="bg-slate-50 py-16 sm:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">
            {c.demoStory.title}
          </h2>
          <p className="mt-4 text-lg text-slate-600">{c.demoStory.subtitle}</p>
        </div>

        <div className="mt-12 grid items-start gap-10 lg:grid-cols-2">
          <div className="lg:rounded-2xl lg:border lg:border-slate-200 lg:bg-white lg:p-6 lg:shadow-sm">
            <div className="flex items-center gap-2 text-sm font-semibold text-slate-900">
              <MessageSquareText className="h-4 w-4" />
              <span>{c.demoStory.promptLabel}</span>
            </div>
            <div className="mt-4 rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm leading-relaxed text-slate-700">
              {c.demoStory.prompt}
            </div>

            <div className="mt-6 lg:hidden">
              <ul className="space-y-3 text-sm text-slate-600">
                <li>
                  <span className="font-semibold text-slate-900">{lang === 'id' ? 'Hasil' : 'Output'}:</span>{' '}
                  {lang === 'id'
                    ? 'Dashboard + metrik + visual yang relevan untuk keputusan cepat.'
                    : 'Dashboard + key metrics + visuals you can act on immediately.'}
                </li>
                <li>
                  <span className="font-semibold text-slate-900">{lang === 'id' ? 'Workflow' : 'Workflow'}:</span>{' '}
                  {lang === 'id'
                    ? 'Tanya → ERICA menyusun → Anda review → ambil aksi.'
                    : 'Ask → ERICA builds → you review → take action.'}
                </li>
              </ul>
            </div>

            <div className="mt-6 hidden gap-3 lg:grid">
              <div className="rounded-xl border border-slate-200 bg-white p-4">
                <div className="text-sm font-semibold text-slate-900">
                  {lang === 'id' ? 'Hasil' : 'Output'}
                </div>
                <div className="mt-1 text-sm text-slate-600">
                  {lang === 'id'
                    ? 'Dashboard + metrik + visual yang relevan untuk keputusan cepat.'
                    : 'Dashboard + key metrics + visuals you can act on immediately.'}
                </div>
              </div>
              <div className="rounded-xl border border-slate-200 bg-white p-4">
                <div className="text-sm font-semibold text-slate-900">
                  {lang === 'id' ? 'Workflow' : 'Workflow'}
                </div>
                <div className="mt-1 text-sm text-slate-600">
                  {lang === 'id'
                    ? 'Tanya → ERICA menyusun → Anda review → ambil aksi.'
                    : 'Ask → ERICA builds → you review → take action.'}
                </div>
              </div>
            </div>
          </div>

          <div>
            <BrowserFrame src={chatDashboardImage} alt={c.demoStory.screenshotAlt} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default EricaDemoStory;
